
let isMultilingual = false;
// console.log('[WizzyCustom] Script loaded. Kosovo Multiple Language:', isMultilingual);

function wizzyLog(label, ...args) {
  // console.log('[WizzyCustom]', label, ...args);
}

function wizzyError(label, error) {
  // console.error('[WizzyCustom]', label, error);
}

function safeForEach(items, callback) {
  if (!Array.isArray(items)) return;
  items.forEach(callback);
}

function safeApplyCommonInit(data) {
  if (!data) return data;

  if (data.store) {
    data.store.currency = data.store.currency || {};
    data.store.currency.symbol = '';
  }

  if (data.search?.configs) {
    if (data.search.configs.pagination) {
      data.search.configs.pagination.appendInExistingList = true;
    }
    if (data.search.configs.facets?.leftFacets) {
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
    }
    if (window.innerWidth >= 1025 && data.search.configs.general) {
      data.search.configs.general.noOfProducts = 25;
    }
  }

  if (data.filters?.configs) {
    data.filters.configs.keepOpenedInMobileAfterApply = true;
    data.filters.configs.layout = 'v1';
  }

  if (window.wizzyConfig?.common?.lazyDOMConfig) {
    window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main'];
  }

  if (data.common?.view?.templates?.literals && window.wizzySettings?.sortByLabel) {
    data.common.view.templates.literals.sortBy = window.wizzySettings.sortByLabel;
  }

  const searchInputSelector =
    window.innerWidth < 768
      ? '.header__search-bar.predictive-search.hidden-desk.hidden-tablet input.predictive-search__input'
      : '.header__search-bar.predictive-search.hidden-tablet.hidden-pocket input.predictive-search__input';

  if (data.common?.lazyDOMConfig?.searchInputIdentifiers?.length) {
    data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      dom: searchInputSelector,
      type: 'text',
    };
  }

  return data;
}

// window.onWizzyScriptLoaded 

window.onWizzyScriptLoaded = function () {
  wizzyLog('onWizzyScriptLoaded called');

  if (!window.wizzyConfig?.events?.registerEvent) {
    wizzyError('onWizzyScriptLoaded aborted: wizzyConfig.events is not available');
    return;
  }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      try {
        // console.log('BEFORE_LAZY_INIT');
        isMultilingual = window.wizzySettings?.isMultilingual; 
        if (!data) return data;

        if (isMultilingual) {
          initMultilingual(data);
        }

        return safeApplyCommonInit(data);
      } catch (error) {
        wizzyError('BEFORE_LAZY_INIT failed', error);
        return data;
      }
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      try {
        isMultilingual = window.wizzySettings?.isMultilingual; 
        if (!data) return data;

        if (isMultilingual) {
          initMultilingual(data);
        }

        if (data.autocomplete?.searchBar) {
          // data.autocomplete.searchBar.hasAnimatedPlaceholders = false;
        }

        return safeApplyCommonInit(data);
      } catch (error) {
        wizzyError('BEFORE_INIT failed', error);
        return data;
      }
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      try {
        wizzyLog('BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER');
        if (!data) return data;

        if (isMultilingual) {
          if (window.Shopify?.locale !== window.wizzySettings?.primaryLanguage) {
            data.topProductsTitle = window.wizzySettings?.secondaryTopProductsLabel;
            data.seeMoreLabel = window.wizzySettings?.secondarySeeMoreLabel;
          } else {
            data.topProductsTitle = window.wizzySettings?.primaryTopProductsLabel;
            data.seeMoreLabel = window.wizzySettings?.primarySeeMoreLabel;
          }
        } else {
          data.topProductsTitle = window.wizzySettings?.primaryTopProductsLabel;
          data.seeMoreLabel = window.wizzySettings?.primarySeeMoreLabel;
        }

        return data;
      } catch (error) {
        wizzyError('BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER failed', error);
        return data;
      }
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (payload) {
      try {
        wizzyLog('AFTER_WIZZY_API_RESPONDED', payload?.api);
        if (!payload?.response?.payload) return payload;

        const facets = payload.response.payload.facets;
        if (
          (payload.api === 'search' || payload.api === 'filter') &&
          Array.isArray(facets)
        ) {
          facets.forEach((facet) => {
            if (!facet) return;

            if (facet.type === 'list' && Array.isArray(facet.data)) {
              facet.data.forEach((item) => {
                if (item && typeof item.label === 'string') {
                  item.label =
                    item.label.charAt(0).toUpperCase() +
                    item.label.slice(1).toLowerCase();
                }
              });
              facet.data.sort((a, b) =>
                (a?.label || '').localeCompare(b?.label || '')
              );
            }

            if (facet.key === 'product_color_hexa_tag' && Array.isArray(facet.data)) {
              facet.data.forEach((item) => {
                if (!item) return;
                item.data = {
                  value: item.label,
                  swatch: {
                    type: 'visual',
                    value: item.label,
                  },
                };
              });
            }
          });

          if (window.Shopify?.locale !== window.wizzySettings?.primaryLanguage) {
            facets.forEach((facet) => {
              if (!Array.isArray(facet.data)) return;

              facet.data.forEach((item) => {
                if (!item?.label) return;

                const translatedValue =
                  facetValueTranslationMapSecondary.get(item.label);

                if (translatedValue) {
                  item.label = translatedValue;
                }
              });
            });
          } else {
            facets.forEach((facet) => {
              if (!Array.isArray(facet.data)) return;

              facet.data.forEach((item) => {
                if (!item?.label) return;

                const translatedValue =
                  facetValueTranslationMapPrimary.get(item.label);

                if (translatedValue) {
                  item.label = translatedValue;
                }
              });
            });
          }
        }

        return payload;
      } catch (error) {
        wizzyError('AFTER_WIZZY_API_RESPONDED failed', error);
        return payload;
      }
    }
  );

  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
    try {
      if (window.Shopify?.locale !== window.wizzySettings?.primaryLanguage) {
        return payload;
      }

      const reverseFacetValueTranslationMap = new Map(
        [...facetValueTranslationMap.entries()].map(([arabic, english]) => [
          english,
          arabic,
        ])
      );

      if (payload?.filters?.attributes) {
        Object.keys(payload.filters.attributes).forEach((attributeKey) => {
          payload.filters.attributes[attributeKey] =
            payload.filters.attributes[attributeKey].map(
              (value) =>
                reverseFacetValueTranslationMap.get(value) || value
            );
        });
      }

      return payload;
    } catch (error) {
      wizzyError('BEFORE_FILTER_EXECUTED failed', error);
      return payload;
    }
  }
);

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      try {
        // console.log(data, "AFTER_PRODUCTS_TRANSFORMED");
        wizzyLog('AFTER_PRODUCTS_TRANSFORMED', Array.isArray(data) ? data.length : 0);
        if (!Array.isArray(data)) return data;

        // const isEnglish = window.Shopify?.locale === 'en';

        data.forEach((product) => {
          if (!product) return;

          // if (isMultilingual && isEnglish && product.url && !product.url.includes('/en/')) {
          //   const url = new URL(product.url, window.location.origin);
          //   product.url = `${url.origin}/en${url.pathname}`;
          // }

          product.hasZeroRating = false;

          if (product.sellingPrice && window.wizzySettings) {
            product.newSellingPrice = formatPrice(
              product.sellingPrice,
              window.wizzySettings.currency,
              window.wizzySettings.locale,
              true
            );
          }

          if (product.newPrice && window.wizzySettings) {
            product.price = formatPrice(
              product.price,
              window.wizzySettings.currency,
              window.wizzySettings.locale,
              true
            );
          }

          if (!Array.isArray(product.attributes)) return;

          product.attributes.forEach((attribute) => {
            if (!attribute?.values?.length) return;

            if (attribute.id === 'product_handle') {
              product.handle = attribute.values[0]?.value?.[0];
            }
            if (attribute.id === 'product_variant_prices' && attribute.values.length > 1) {
              product.hasToShowQuickView = true;
            }
            if (attribute.id === 'product_ratings_count_reviews') {
              product.totalReviews = attribute.values[0]?.value?.[0];
            }
            if (attribute.id === 'product_product_rating_reviews') {
              const ratingValue = attribute.values[0]?.value?.[0];
              if (ratingValue != null) {
                product.ratingStars = getRatingStarsHtml(ratingValue);
                product.hasZeroRating = true;
                product.avgRatings = ratingValue;
              }
            }
          });
        });

        const wizzyEl = document.querySelector('.wizzy-main-content');
        if (wizzyEl) {
          let sibling = wizzyEl.nextElementSibling;
          while (sibling) {
            if (sibling.classList?.contains('shopify-section')) {
              sibling.style.display = 'none';
            }
            sibling = sibling.nextElementSibling;
          }
        }

        return data;
      } catch (error) {
        wizzyError('AFTER_PRODUCTS_TRANSFORMED failed', error);
        return data;
      }
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      try {
        wizzyLog('BEFORE_RENDER_RESULTS', payload?.api);
        if (!payload?.response?.payload) return payload;

        if (payload.api === 'search' || payload.api === 'filter') {
          const facets = payload.response.payload.facets;
          if (!Array.isArray(facets)) return payload;

          facets.forEach((facet) => {
            if (!facet || facet.key !== 'sizes' || !Array.isArray(facet.data)) return;

            const sizeOrderMap = {};
            availableSizeStrings.forEach((size, index) => {
              sizeOrderMap[size.toUpperCase()] = index;
            });

            facet.data = facet.data.slice().sort((a, b) => {
              const aVal = (a?.key || '').toUpperCase();
              const bVal = (b?.key || '').toUpperCase();
              const aIndex = Object.prototype.hasOwnProperty.call(sizeOrderMap, aVal)
                ? sizeOrderMap[aVal]
                : Infinity;
              const bIndex = Object.prototype.hasOwnProperty.call(sizeOrderMap, bVal)
                ? sizeOrderMap[bVal]
                : Infinity;

              if (aIndex === Infinity && bIndex === Infinity) return 0;
              return aIndex - bIndex;
            });
          });
        }

        return payload;
      } catch (error) {
        wizzyError('BEFORE_RENDER_RESULTS failed', error);
        return payload;
      }
    }
  );

  function formatPriceTooltips() {
    if (!window.wizzySettings) return;

    const tooltips = document.querySelectorAll('.noUi-tooltip');
    if (!tooltips.length) return;

    tooltips.forEach((tooltip) => {
      if (!tooltip) return;
      setTimeout(() => {
        if (!tooltip.isConnected) return;
        const rawValue = tooltip.textContent.replace(/[^\d.-]/g, '');
        const numericValue = parseFloat(rawValue);

        if (!isNaN(numericValue)) {
          tooltip.textContent = formatPrice(
            numericValue,
            window.wizzySettings.currency,
            window.wizzySettings.locale,
            true
          );
        }
      }, 100);
    });
  }

  let priceTooltipObserverAttached = false;

  function attachPriceTooltipObserver() {
    if (priceTooltipObserverAttached) return;

    const handleElement = document.querySelector('.noUi-handle');
    if (!handleElement) return;

    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (
          mutation.attributeName === 'aria-valuemax' ||
          mutation.attributeName === 'aria-valuemin'
        ) {
          formatPriceTooltips();
          break;
        }
      }
    });

    observer.observe(handleElement, { attributes: true });
    priceTooltipObserverAttached = true;
  }

  function handleViewRendered(data) {
    wizzyLog('VIEW_RENDERED');

    const facetList = document.querySelector(
      '.wizzy-facet-body.facet-body-inStock .wizzy-facet-list'
    );

    if (facetList) {
      const items = Array.from(facetList.querySelectorAll('.wizzy-facet-list-item'));

      // items.forEach((el) => {
      //   const labelEl = el.querySelector('.facet-item-label-value');
      //   if (!labelEl) return;

      //   const text = labelEl.textContent.trim().toLowerCase();
      //   if (text === 'in stock' && window.wizzySettings?.inStockLabel) {
      //     labelEl.textContent = window.wizzySettings.inStockLabel;
      //   } else if (text === 'out of stock' && window.wizzySettings?.outOfStockLabel) {
      //     labelEl.textContent = window.wizzySettings.outOfStockLabel;
      //   }
      // });

      items.sort((a, b) => {
        const aLabel =
          a.querySelector('.facet-item-label-value')?.textContent.trim().toLowerCase() || '';
        const bLabel =
          b.querySelector('.facet-item-label-value')?.textContent.trim().toLowerCase() || '';
        return bLabel.localeCompare(aLabel);
      });

      facetList.innerHTML = '';
      items.forEach((item) => facetList.appendChild(item));
    }

    document
      .querySelectorAll('.product-item__image-wrapper.product-item__image-wrapper--multiple img')
      .forEach((img) => {
        if (!img?.src) return;

        if (img.src.includes('https://via.placeholder.com/360x360')) {
          img.src = img.src
            .replace(
              'https://via.placeholder.com/360x360',
              'https://placehold.co/360x360/3642b8/FFF?font=roboto&text=Decathlon'
            )
            .replace(/;width=\d+/g, '');
        }

        if (img.srcset && img.srcset.includes('https://via.placeholder.com/360x360')) {
          img.srcset = img.srcset
            .replaceAll(
              'https://via.placeholder.com/360x360',
              'https://placehold.co/360x360/3642b8/FFF?font=roboto&text=Decathlon'
            )
            .replace(/;width=\d+/g, '');
        }
      });

    // if (window.wizzySettings?.outOfStockLabel || window.wizzySettings?.inStockLabel) {
    //   document
    //     .querySelectorAll('.wizzy-selected-facet-list-item-label .facet-item-label-value')
    //     .forEach((el) => {
    //       Array.from(el.childNodes).forEach((node) => {
    //         if (node.nodeType !== Node.TEXT_NODE) return;

    //         const text = node.textContent.trim().toLowerCase();
    //         if (text === 'out of stock' && window.wizzySettings.outOfStockLabel) {
    //           node.textContent = window.wizzySettings.outOfStockLabel;
    //         }
    //         if (text === 'in stock' && window.wizzySettings.inStockLabel) {
    //           node.textContent = window.wizzySettings.inStockLabel;
    //         }
    //       });
    //     });
    // }

    formatPriceTooltips();
    attachPriceTooltipObserver();
    gridFiltersToggleOnOverflow();

    return data;
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      try {
        return handleViewRendered(data);
      } catch (error) {
        wizzyError('VIEW_RENDERED failed', error);
        return data;
      }
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      try {
        wizzyLog('PRODUCTS_CACHED_RESULTS_RENDERED');
        gridFiltersToggleOnOverflow();
        return data;
      } catch (error) {
        wizzyError('PRODUCTS_CACHED_RESULTS_RENDERED failed', error);
        return data;
      }
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      try {
        wizzyLog('BEFORE_SEARCH_EXECUTED');
        if (!payload) return payload;

        payload.minQueryLength = 1;

        if (window.wizzyConfig?.common?.lazyDOMConfig) {
          window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main'];
        }

        const searchDrawer = document.querySelector('#search-drawer');
        if (searchDrawer) {
          searchDrawer.removeAttribute('open');
        }

        return payload;
      } catch (error) {
        wizzyError('BEFORE_SEARCH_EXECUTED failed', error);
        return payload;
      }
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      try {
        wizzyLog('BEFORE_AUTOCOMPLETE_EXECUTED');
        if (!payload) return payload;

        payload.minQueryLength = 1;
        return payload;
      } catch (error) {
        wizzyError('BEFORE_AUTOCOMPLETE_EXECUTED failed', error);
        return payload;
      }
    }
  );

  document.addEventListener("click", function (event) {
    const innerLabel = event.target.closest(".wizzy-common-select-innerlabel");
    if (innerLabel) {
      const container = innerLabel.closest(".wizzy-common-select-container");
      if (container) {
        const options = container.querySelector(".wizzy-common-select-options");
        const overlay = container.querySelector(".wizzy-common-select-overlay");

        if (options) options.style.display = "none";
        if (overlay) overlay.style.display = "none";
        document.body.classList.remove("wizzy-overlay-opened");
        document.body.classList.remove("wizzy-common-select-body-overlay");

      }
    }
  });

}



function initMultilingual(data) {
  if (!data) return;

  const locale = window.Shopify?.locale;
  if (locale == window.wizzySettings?.primaryLanguage) return;

  if (data.search?.configs?.general) {
    data.search.configs.general.searchEndpoint = window.wizzySettings.secondaryStoreSearchEndpoint;
  }

  window.wizzyConfig.credentials = {
    apiKey: window.wizzySettings.secondaryStoreApiKey,
    storeId: window.wizzySettings.secondaryStoreId,
  };

  safeForEach(data.search?.configs?.facets?.configs, (item) => {
    if (item && facetLabelConversionMap.has(item.label)) {
      item.label = facetLabelConversionMap.get(item.label);
    }
  });

  safeForEach(data.search?.configs?.sorts?.configs, (item) => {
    if (item && sortLabelConversionMap.has(item.label)) {
      item.label = sortLabelConversionMap.get(item.label);
    }
  });

  safeForEach(data.autocomplete?.configs?.defaultBehaviour?.suggestions?.defaultPool, (item) => {
    if (!item) return;
    if (popularSuggestionsConversionMap.has(item.value)) {
      item.value = popularSuggestionsConversionMap.get(item.value);
    }
    if (popularSuggestionsConversionMap.has(item.valueHighlighted)) {
      item.valueHighlighted = popularSuggestionsConversionMap.get(item.valueHighlighted);
    }
  });

  const animatedPlaceholders = data.autocomplete?.searchBar?.animatedPlaceholders;
  if (Array.isArray(animatedPlaceholders)) {
    data.autocomplete.searchBar.animatedPlaceholders = animatedPlaceholders.map(
      (item) => animatedPlaceHolderConversionMap.get(item) || item
    );
  }

  if (data.autocomplete?.menu) {
    data.autocomplete.menu.brands = data.autocomplete.menu.brands || {};
    data.autocomplete.menu.categories = data.autocomplete.menu.categories || {};
    data.autocomplete.menu.others = data.autocomplete.menu.others || {};
    data.autocomplete.menu.brands.title = window.wizzySettings.secondaryBrandsLabel;
    data.autocomplete.menu.categories.title =  window.wizzySettings.secondaryCategoryLabel;
    data.autocomplete.menu.others.title = window.wizzySettings.secondaryTrendingSearchLabel;
  }

  if (data.autocomplete?.topProducts) {
    data.autocomplete.topProducts.title = 'Top Products';
  }

  // if (data.search?.view?.templates?.literals) {
  //   data.search.view.templates.literals.emptySearchResultPageTitle =
  //     'لم نتمكن من العثور على أي نتائج!';
  // }

  if (document.body) {
    document.body.classList.add('wizzy-ar-language');
  }

  safeForEach(data.gridFilters?.filters, (item) => {
    if (item && questionConversionMap.has(item.question)) {
      item.question = questionConversionMap.get(item.question);
    }
  });
}

// function checkWizzyConfigAndUpdate() {
//   try {
//     if (
//       window.wizzyConfig?.autocomplete?.searchBar?.animatedPlaceholders &&
//       Array.isArray(window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders)
//     ) {
//       window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders =
//         window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders.map(
//           (item) => animatedPlaceHolderConversionMap.get(item) || item
//         );
//     }
//     clearInterval(interval);
//   } catch (error) {
//     wizzyError('checkWizzyConfigAndUpdate failed', error);
//   }
// }
// var interval = setInterval(checkWizzyConfigAndUpdate, 100);

const availableSizeStrings = [
    "2XS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "0",
    "27/30",
    "31/34",
    "35/38",
    "39/42",
    "43/46",
    "47/50",
    "25/26",
    "27/28",
    "29/30",
    "31/32",
    "32/33",
    "33/34",
    "35/36",
    "37/38",
    "39/40",
    "41/42",
    "43/44",
    "45/46",
    "47/48",
    "1",
    "2",
    "3",
    "4",
    "5",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "50",
    "52",
    "6 Ans",
    "8 Ans",
    "12 Ans",
    "14 Ans",
    "10-11 Ans / 141-148 cm",
    "10-11 Ans / 141-150 cm",
    "12 Mois / 73-75 cm",
    "12-13 Ans / 149-159 cm",
    "12-13 Ans / 151-160 cm",
    "14-15 Ans / 160-166 cm",
    "14-15 Ans / 161-172 cm",
    "18 Mois / 76-81 cm",
    "2-3 Ans / 89-95 cm",
    "24 Mois / 82-88 cm",
    "2XL / W38 L31",
    "3-4 Ans / 96-102 cm",
    "3XL / W41 L31",
    "4-5 Ans / 103-112 cm",
    "5-6 Ans / 113-122 cm",
    "6 Mois / 61-69 cm",
    "7-8 Ans / 123-130 cm",
    "8-9 Ans / 131-140 cm",
    "ADULTE",
    "L / W33 L29",
    "L / W33 L31",
    "M / W30 L29",
    "M / W30 L31",
    "S / W28 L29",
    "S / W28 L31",
    "Taille unique",
    "UNIQUE",
    "XL / W35 L31",
    "XS / W26 L28",
    "XS / W26 L30"
];

// function formatPrice(amount, currency = "USD", locale = "en-US", useCodeInsteadOfSymbol = false) {
//   if (typeof amount === "string") {
//     amount = parseFloat(amount.replace(/,/g, ""));
//   }

//   // Safety: if parsing fails, default to 0
//   if (isNaN(amount)) amount = 0;

//   // Format the number without decimals
//   let formattedNumber = new Intl.NumberFormat(locale, {
//     minimumFractionDigits: isMultilingual ? 0 : 0,
//     maximumFractionDigits: isMultilingual ? 0 : 0
//   }).format(amount);
  
//   if(isMultilingual){
//     formattedNumber = amount.toFixed(2).replace(".", ",");
//   }  
//   // Return formatted output
//   if (useCodeInsteadOfSymbol) {
//     return `${currency} ${formattedNumber}`;
//   }

//   // Default to normal currency style
//   return new Intl.NumberFormat(locale, {
//     style: "currency",
//     currency: currency,
//   }).format(amount);
// }

function formatPrice(amount, currency = "USD", locale = "en-US", useCodeInsteadOfSymbol = false) {
  if (typeof amount === "string") {
    amount = parseFloat(amount.replace(/,/g, ""));
  }

  if (isNaN(amount)) amount = 0;

  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount)
    .replace(',', '.') // Replace the decimal comma with a decimal dot;
    .replace(/\s/g, ',') // Replace spaces (including non-breaking spaces) with commas

  if (useCodeInsteadOfSymbol) {
    return `${currency}${formattedNumber}`;
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}
function gridFiltersToggleOnOverflow() {
  if (window.innerWidth <= 768) return;

  const filterBoxes = document.querySelectorAll('.wizzy-grid-filters-box');
  if (!filterBoxes.length) return;

  filterBoxes.forEach((box) => {
    if (!box) return;

    const filterList = box.querySelector('.wizzy-facet-body .wizzy-facet-list');
    const toggleBtn = box.querySelector('.wizzy-facet-body .wizzy-toggle-btn');
    const filterOptions = box.querySelector('.wizzy-facet-body');

    if (
      !filterList ||
      !toggleBtn ||
      !filterOptions ||
      toggleBtn.classList.contains('wizzy-click-event-attached')
    ) {
      return;
    }

    const filterHeight = filterList.offsetHeight;
    const lineHeight = parseFloat(getComputedStyle(filterList).lineHeight);
    const maxVisibleLines = 2;
    const visibleLines = Math.floor(filterHeight / lineHeight) - 1;
    const toggleText = toggleBtn.querySelector('span');

    if (visibleLines > maxVisibleLines) {
      filterOptions.classList.add('collapsed');
      toggleBtn.classList.add('wizzy-click-event-attached');
      toggleBtn.style.display = 'inline-block';
      if (toggleText && window.wizzySettings?.moreLabel) {
        toggleText.textContent = window.wizzySettings.moreLabel;
      }
    } else {
      toggleBtn.style.display = 'none';
      return;
    }

    toggleBtn.addEventListener('click', function () {
      if (filterOptions.classList.contains('collapsed')) {
        filterOptions.classList.remove('collapsed');
        filterOptions.classList.add('expanded');
        if (toggleText && window.wizzySettings?.lessLabel) {
          toggleText.textContent = window.wizzySettings.lessLabel;
        }
      } else {
        filterOptions.classList.remove('expanded');
        filterOptions.classList.add('collapsed');
        if (toggleText && window.wizzySettings?.moreLabel) {
          toggleText.textContent = window.wizzySettings.moreLabel;
        }
      }
    });
  });
}
function getRatingStarsHtml(rating, maxStars = 5) {
  
  var container = "";
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.25 && rating % 1 < 0.75;
  const totalStars = hasHalf ? fullStars + 1 : Math.round(rating);

  for (let i = 0; i < fullStars; i++) {
    container += `
      <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star   rating__star rating__star--full" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="currentColor"></path>
      </svg>
    `;
  }

  if (hasHalf) {
    container += `
     <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star-half   rating__star rating__star--half" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="url(#rating-star-gradient-half)"></path>
      </svg>
    `;
  }

  for (let i = totalStars; i < maxStars; i++) {
    container += `
     <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star   rating__star rating__star--empty" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="#3643BA66"></path>
      </svg>
    `;
  
  }
  return container;
}
function waitForInputAndAttach() {
  const input = document.getElementsByClassName('.predictive-search__input.wizzy-search-input');
  // if (!input) {
  //   return setTimeout(waitForInputAndAttach, 100);
  // }

  // input.addEventListener('focus', () => {
  //   document.body.classList.add('wizzyMobileAutoComplete');
  // });

  // input.addEventListener('blur', () => {
  //   document.body.classList.remove('wizzyMobileAutoComplete');
  // });
}
 waitForInputAndAttach();
window.addEventListener('scroll', function () {
    const searchBar = window.innerWidth > 768 ? 
      document.querySelector(".header__inline-navigation .header__search-bar .predictive-search__input") : 
      document.querySelector(".header__search-bar.hidden-desk.hidden-tablet .predictive-search__input");
    const wizzyAutoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

    if (!searchBar || !wizzyAutoComplete) return;

    const searchBarRect = searchBar.getBoundingClientRect();
    const topPosition = searchBarRect.top + searchBarRect.height;
    wizzyAutoComplete.style.top = `${topPosition}px`;
});


function updateAnimatedPlaceholders() {
  if (window.Shopify?.locale == window.wizzySettings?.primaryLanguage) return;

  const placeholders = window.wizzyConfig?.autocomplete?.searchBar?.animatedPlaceholders;
 

  if (!Array.isArray(placeholders)) return;

  window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders =
    placeholders.map(
      (item) => animatedPlaceHolderConversionMap.get(item) || item
    );
}

// Run immediately
updateAnimatedPlaceholders();

// Watch for Wizzy config updates
const wizzyConfigObserver = new MutationObserver(() => {
  updateAnimatedPlaceholders();
});

wizzyConfigObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});